import graphqlClient from "../../../apollo";

class CashRegisterProvider {

    findCashRegister(id) {
        return graphqlClient.query({
            query: require('./gql/CashRegister/findCashRegister.graphql'),
            variables: {id:id},
            fetchPolicy: "network-only"
        })
    }

    paginateCashRegister(pageNumber, itemsPerPage, search = null, filters = null,  orderBy = null, orderDesc = false) {
        return graphqlClient.query({
            query: require('./gql/CashRegister/paginateCashRegister.graphql'),
            variables: {pageNumber, itemsPerPage, search, filters, orderBy, orderDesc},
            fetchPolicy: "network-only"
        })
    }

    createCashRegister(input) {
        return graphqlClient.mutate({
            mutation: require('./gql/CashRegister/createCashRegister.graphql'),
            variables: {input}
        })
    }

    updateCashRegister(id,input) {
        return graphqlClient.mutate({
            mutation: require('./gql/CashRegister/updateCashRegister.graphql'),
            variables: {id, input}
        })
    }

    deleteCashRegister(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/CashRegister/deleteCashRegister.graphql'),
            variables: {id}
        })
    }
}

export default new CashRegisterProvider()
